var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'inline-flex justify-center items-center px-2.5 py-0.5 rounded-lg font-medium whitespace-nowrap',
        ..._vm.colorClass, _vm.large ? 'text-lg' : '', _vm.small ? 'text-sm' : '', _vm.dull ? 'opacity-70' : '',
        _vm.xSmall ? 'text-xs' : '' ,
    ],style:(_vm.minWidthStyle)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }